import React, {useState, useEffect} from 'react'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {IProfileDetails} from './SettingsModel'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import axios from 'axios'
import Swal from 'sweetalert2'
import {useNavigate} from 'react-router-dom'
import {initialQueryState, KTIcon, useDebounce} from '../../../../_metronic/helpers'
import '../../index.css'
const profileDetailsSchema = Yup.object().shape({
  fName: Yup.string().required('First name is required'),
  lName: Yup.string().required('Last name is required'),
  code: Yup.string().required('code is required'),
  contactPhone: Yup.string().required('Contact phone is required'),
})

const UploadExcel: React.FC = () => {
  const navigate = useNavigate()
  const API_URL = process.env.REACT_APP_API_URL
  const initialValues: IProfileDetails = {
    fName: '',
    lName: '',
    contactPhone: '',
    code: '',
    email: ''
  }
  const [data, setData] = useState<IProfileDetails>(initialValues)
  const updateData = (fieldsToUpdate: Partial<IProfileDetails>): void => {
    const updatedData = Object.assign(data, fieldsToUpdate)
    setData(updatedData)
  }

  const AlertError = (message: string) => {
    Swal.fire('', message, 'error')
  }

  useEffect(
    () => {},
    [] // Only re-call effect if value or delay changes
  )

  const uploadExcel = async (e: any) => {
    if (e.target.files.length) {
      e.preventDefault()
      var _URL = window.URL || window.webkitURL
      var file = e.target.files[0]
      var formdata = new FormData()
      formdata.append('image', file)
      var requestOptions = {
        method: 'POST',
        body: formdata,
        redirect: 'follow',
      }
      const data = await axios.post(`${API_URL}/upload`, formdata)
    }
  }

  const [loading, setLoading] = useState(false)
  const formik = useFormik<IProfileDetails>({
    initialValues,
    validationSchema: profileDetailsSchema,
    onSubmit: (values) => {
      console.log(values)
      setLoading(true)
      setTimeout(async () => {
        //values.communications.email = data.communications.email
        //values.communications.phone = data.communications.phone
        //values.allowMarketing = data.allowMarketing
        const updatedData = Object.assign(data, values)
        setData(updatedData)
        Swal.fire({
          title: '',
          text: 'Confirm Edit',
          icon: 'info',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          showLoaderOnConfirm: true,
        }).then(async (result) => {
          if (result.isConfirmed) {
            const data0 = await axios
              .put(`${API_URL}/bo/participant/${1}`, {
                firstname: values.fName,
                lastname: values.lName,
                mobile_number: values.contactPhone,
              })
              .then(async (res) => {
                await Swal.fire('Success', 'Success', 'success')
                navigate(-1)
              })
              .catch((err) => {
                Swal.fire('Edit !', 'Your can not Edit. !! ' + err, 'error')
              })
          }
        })

        setLoading(false)
      }, 1000)
    },
  })

  return (
    <div className='card mb-5 mb-xl-10'>
      <div id='kt_account_profile_details' className='collapse show'>
        <form onSubmit={formik.handleSubmit} noValidate className='form'>
          <div className='card-body border-top p-9'>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>
                <span>Excel</span>
              </label>

              <div className='col-lg-6 fv-row'>
                <input
                  disabled={true}
                  type='tel'
                  className='form-control form-control-lg form-control-solid'
                  placeholder=''
                  {...formik.getFieldProps('code')}
                />
              </div>
              <div className='col-lg-2 fv-row'>
                <span className='btn btn-primary btn-file wbt editbtn'>
                  {!loading && 'Add File'}
                  {loading && (
                    <span className='indicator-progress' style={{display: 'block'}}>
                      Please wait...{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                  <input disabled={loading} type='file' accept='.xlsx' onChange={uploadExcel} />
                </span>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export {UploadExcel}
